import { Outlet } from 'react-router-dom';

const PublicOutlet = () => (
    <Outlet />
);

export default PublicOutlet;
